import Vuex from 'vuex';

import ContentStoreModule from '../content/store/ContentStoreModule';
import SelectProfileStoreModule from './store/SelectProfileStoreModule';

export function getStore(){
    // Create custom store comprised of required sub-modules
    return new Vuex.Store({
        modules: {
            content: ContentStoreModule,
            selectProfile: SelectProfileStoreModule
        }
    });
}
